<template>
  <div class="search_listBox">
    <div class="center">
      <!--相关视频-->
      <div class="correlation_video" v-if="this.$route.query.id=='1'">
        <div class="video_center">
          <div class="item_list">
            <img src="../../../assets/images/home/ceshi3.jpeg" alt="">
            <div>【<div>关键字</div>】
              <span>视频标题</span>
            </div>
          </div>
          <div class="item_list">
            <img src="../../../assets/images/home/ceshi3.jpeg" alt="">
            <div>【<div>关键字</div>】
              <span>视频标题</span>
            </div>
          </div>
          <div class="item_list">
            <img src="../../../assets/images/home/ceshi3.jpeg" alt="">
            <div>【<div>关键字</div>】
              <span>视频标题</span>
            </div>
          </div>
          <div class="item_list">
            <img src="../../../assets/images/home/ceshi3.jpeg" alt="">
            <div>【<div>关键字</div>】
              <span>视频标题</span>
            </div>
          </div>
          <div class="item_list">
            <img src="../../../assets/images/home/ceshi3.jpeg" alt="">
            <div>【<div>关键字</div>】
              <span>视频标题</span>
            </div>
          </div>
          <div class="item_list">
            <img src="../../../assets/images/home/ceshi3.jpeg" alt="">
            <div>【<div>关键字</div>】
              <span>视频标题</span>
            </div>
          </div>
          <div class="item_list">
            <img src="../../../assets/images/home/ceshi3.jpeg" alt="">
            <div>【<div>关键字</div>】
              <span>视频标题</span>
            </div>
          </div>
          <div class="item_list">
            <img src="../../../assets/images/home/ceshi3.jpeg" alt="">
            <div>【<div>关键字</div>】
              <span>视频标题</span>
            </div>
          </div>
          <div class="item_list">
            <img src="../../../assets/images/home/ceshi3.jpeg" alt="">
            <div>【<div>关键字</div>】
              <span>视频标题</span>
            </div>
          </div>
        </div>
      </div>
      <!--相关语音-->
      <div class="correlation_voice" v-if="this.$route.query.id=='2'">
        <div class="voice_center">
          <div class="item_list">
            <div class="item_title">
              <div>肝炎的早期症状有哪些肝炎的早期症状有哪些肝炎的早期症状有哪些肝炎的早期症状有哪些？怎样预防</div>
            </div>
            <div class="audio_box">
              <audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">
              </audio>
            </div>
            <div class="doctor_head">
              <div class="doctor_name">张三三</div>
              <div class="doctor_hospital">北京协和医院</div>
              <div class="doctor_twoTitle">儿科医院</div>
              <span>2020-03-02</span>
            </div>
          </div>
          <div class="item_list">
            <div class="item_title">
              <div>肝炎的早期症状有哪些肝炎的早期症状有哪些肝炎的早期症状有哪些肝炎的早期症状有哪些？怎样预防</div>
            </div>
            <div class="audio_box">
              <audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">
              </audio>
            </div>
            <div class="doctor_head">
              <div class="doctor_name">张三三</div>
              <div class="doctor_hospital">北京协和医院</div>
              <div class="doctor_twoTitle">儿科医院</div>
              <span>2020-03-02</span>
            </div>
          </div>
          <div class="item_list">
            <div class="item_title">
              <div>肝炎的早期症状有哪些肝炎的早期症状有哪些肝炎的早期症状有哪些肝炎的早期症状有哪些？怎样预防</div>
            </div>
            <div class="audio_box">
              <audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">
              </audio>
            </div>
            <div class="doctor_head">
              <div class="doctor_name">张三三</div>
              <div class="doctor_hospital">北京协和医院</div>
              <div class="doctor_twoTitle">儿科医院</div>
              <span>2020-03-02</span>
            </div>
          </div>
          <div class="item_list">
            <div class="item_title">
              <div>肝炎的早期症状有哪些肝炎的早期症状有哪些肝炎的早期症状有哪些肝炎的早期症状有哪些？怎样预防</div>
            </div>
            <div class="audio_box">
              <audio src="http://vjs.zencdn.net/v/oceans.mp4" controls="controls" controlsList="nodownload">
              </audio>
            </div>
            <div class="doctor_head">
              <div class="doctor_name">张三三</div>
              <div class="doctor_hospital">北京协和医院</div>
              <div class="doctor_twoTitle">儿科医院</div>
              <span>2020-03-02</span>
            </div>
          </div>
        </div>
      </div>
      <!--相关文章-->
      <div class="correlation_text" v-if="this.$route.query.id=='3'">
        <div class="text_center">
          <div class="item_list">
            <div class="text_title">
              <div>肝炎的早期症状有哪些？怎样预防？</div>
              <span>2020-04-17</span>
            </div>
            <div class="text_card">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</div>
          </div>
          <div class="item_list">
            <div class="text_title">
              <div>肝炎的早期症状有哪些？怎样预防？</div>
              <span>2020-04-17</span>
            </div>
            <div class="text_card">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</div>
          </div>
          <div class="item_list">
            <div class="text_title">
              <div>肝炎的早期症状有哪些？怎样预防？</div>
              <span>2020-04-17</span>
            </div>
            <div class="text_card">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</div>
          </div>
          <div class="item_list">
            <div class="text_title">
              <div>肝炎的早期症状有哪些？怎样预防？</div>
              <span>2020-04-17</span>
            </div>
            <div class="text_card">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</div>
          </div>
          <div class="item_list">
            <div class="text_title">
              <div>肝炎的早期症状有哪些？怎样预防？</div>
              <span>2020-04-17</span>
            </div>
            <div class="text_card">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</div>
          </div>
          <div class="item_list">
            <div class="text_title">
              <div>肝炎的早期症状有哪些？怎样预防？</div>
              <span>2020-04-17</span>
            </div>
            <div class="text_card">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</div>
          </div>
        </div>
      </div>
      <!--相关问答-->
      <div class="correlation_answer" v-if="this.$route.query.id=='4'">
        <div class="answer_center">
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <div>Q</div>
                <span>小孩蛀牙吃什么药效果好？</span>
                <p>2020-01-05</p>
              </div>
              <div class="list_twoBox_A">
                <div>A</div>
                <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
                <p>2020-04-02</p>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_title">主任医师</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <div>Q</div>
                <span>小孩蛀牙吃什么药效果好？</span>
                <p>2020-01-05</p>
              </div>
              <div class="list_twoBox_A">
                <div>A</div>
                <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
                <p>2020-04-02</p>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_title">主任医师</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
          <div class="item_List">
            <div class="list_twoBox">
              <div class="list_twoBox_Q">
                <div>Q</div>
                <span>小孩蛀牙吃什么药效果好？</span>
                <p>2020-01-05</p>
              </div>
              <div class="list_twoBox_A">
                <div>A</div>
                <span>蛀牙也就是龋齿，发展到一定阶段的时候，牙齿会出现疼痛。孩子蛀牙疼痛，如果吃东西的时候疼，平时不吃东西的时候不疼，可以让孩子吃软食，暂时不用牙疼的那一侧咀嚼食物，不需要用药。…………</span>
                <p>2020-04-02</p>
              </div>
              <div class="list_twoBox_bottom">
                <div class="doctor_head">
                  <img src="../../../assets/images/home/ceshi2.jpeg" alt="">
                  <div class="doctor_name">张三三</div>
                  <div class="doctor_title">主任医师</div>
                  <div class="doctor_hospital">北京协和医院</div>
                  <div class="doctor_twoTitle">儿科医院</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--相关医生-->
      <div class="correlation_doctor"v-if="this.$route.query.id=='5'" >
        <div class="doctor_center">
          <div class="item_list">
            <div class="headerImg">
              <img src="../../../assets/images/home/ceshi1.jpeg" alt="">
            </div>
            <div class="doctor_name">
              <div class="top">
                <div>张主任</div>
                <span>主任医师</span>
              </div>
              <div class="bottom">
                <div>北京协和医院</div>
                <span>呼吸内科主任</span>
              </div>
            </div>
            <div class="doctor_info">
              <div>sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. </div>
            </div>
          </div>
          <div class="item_list">
            <div class="headerImg">
              <img src="../../../assets/images/home/ceshi1.jpeg" alt="">
            </div>
            <div class="doctor_name">
              <div class="top">
                <div>张主任</div>
                <span>主任医师</span>
              </div>
              <div class="bottom">
                <div>北京协和医院</div>
                <span>呼吸内科主任</span>
              </div>
            </div>
            <div class="doctor_info">
              <div>sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. </div>
            </div>
          </div>
          <div class="item_list">
            <div class="headerImg">
              <img src="../../../assets/images/home/ceshi1.jpeg" alt="">
            </div>
            <div class="doctor_name">
              <div class="top">
                <div>张主任</div>
                <span>主任医师</span>
              </div>
              <div class="bottom">
                <div>北京协和医院</div>
                <span>呼吸内科主任</span>
              </div>
            </div>
            <div class="doctor_info">
              <div>sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. </div>
            </div>
          </div>
          <div class="item_list">
            <div class="headerImg">
              <img src="../../../assets/images/home/ceshi1.jpeg" alt="">
            </div>
            <div class="doctor_name">
              <div class="top">
                <div>张主任</div>
                <span>主任医师</span>
              </div>
              <div class="bottom">
                <div>北京协和医院</div>
                <span>呼吸内科主任</span>
              </div>
            </div>
            <div class="doctor_info">
              <div>sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. </div>
            </div>
          </div>
          <div class="item_list">
            <div class="headerImg">
              <img src="../../../assets/images/home/ceshi1.jpeg" alt="">
            </div>
            <div class="doctor_name">
              <div class="top">
                <div>张主任</div>
                <span>主任医师</span>
              </div>
              <div class="bottom">
                <div>北京协和医院</div>
                <span>呼吸内科主任</span>
              </div>
            </div>
            <div class="doctor_info">
              <div>sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. </div>
            </div>
          </div>
          <div class="item_list">
            <div class="headerImg">
              <img src="../../../assets/images/home/ceshi1.jpeg" alt="">
            </div>
            <div class="doctor_name">
              <div class="top">
                <div>张主任</div>
                <span>主任医师</span>
              </div>
              <div class="bottom">
                <div>北京协和医院</div>
                <span>呼吸内科主任</span>
              </div>
            </div>
            <div class="doctor_info">
              <div>sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Pagination">
      <Pagination  :pageSize="pageSize" v-model="dataForm.page" @on-jump="jump" />
    </div>

  </div>
</template>

<script>
  import Pagination from '../../../components/pagination/index'
  export default {
    name: "List",
    components:{
      Pagination
    },
    data() {
      return {
        pageSize:10,  // 总分页数
        dataForm:{
          page:10,
        }
      }
    },
    methods:{
      jump(page){
        console.log(page);
      }
    },
    mounted() {

    },
  }
</script>
<style lang="stylus" scoped>
  div{
    box-sizing border-box
  }
  .search_listBox{
    margin-top 30px
    .center{
      // 相关视频
      .correlation_video{
        .video_center{
          display flex
          flex-wrap: wrap
          .item_list{
            cursor: pointer
            display flex
            flex-direction column
            align-items center
            margin-right 20px
            margin-bottom 20px
            &:nth-child(3n){
              margin-right 0px
            }
            >img{
              width: 267px;
              height: 168px;
            }
            >div{
              display flex
              font-weight: 700;
              font-size: 14px;
              color: #333
              margin-top 10px
              >div{
                color: #FF0000
                font-size 14px
                font-weight 700
              }
              >span{
                display block
                font-weight: 700;
                font-size: 14px;
                color: #333
              }
            }
          }
        }
      }
      // 相关语音
      .correlation_voice{
        .voice_center{
          margin-bottom 40px
          .item_list{
            &:after{
              content ''
              display block
              width: 100%
              height: 1px
              border-top 1px dashed #d2d2d2
              margin 30px 0
            }
            &:last-child{
              &:after{
                display none
              }
            }
            .item_title{
              cursor: pointer
              display flex
              justify-content space-between
              align-items center
              >div{
                max-width: 80%
                font-weight: 700;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .audio_box{
              margin 20px 0
              >audio{
                width: 249px
                height: 31px
              }
            }
            .doctor_head{
              display flex
              align-items center
              margin-top 20px
              position relative
              >img{
                width: 60px;
                height: 60px;
                border-radius 50%
                margin-right 15px
              }
              .doctor_name{
                font-weight: 700;
                font-style: normal;
                font-size: 14px;
                color: #5E5E5E;
                margin-right 15px
                max-width: 100px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .doctor_hospital{
                font-size: 14px;
                color: #5E5E5E;
                margin-right 15px
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width 400px
              }
              .doctor_twoTitle{
                font-size: 14px;
                color: #5E5E5E;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width 250px
              }
              >span{
                position absolute
                right 0
                display block
                font-size: 12px
                color: #C9C9C9
              }
            }
          }
        }
      }
      // 相关文章
      .correlation_text{
        .text_center{
          .item_list{
            margin-bottom 30px
            .text_title{
              cursor: pointer
              display flex
              justify-content space-between
              align-items center
              >div{
                max-width: 80%
                font-weight: 700;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              >span{
                color: #C9C9C9;
                font-size 12px
              }
            }
            .text_card{
              margin-top 15px
              font-size: 12px;
              line-height: 22px;
              color: #666
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }

        }
      }
      // 相关问答
      .correlation_answer{
        .answer_center{
          margin-top 20px
          .item_List{
            margin-top 15px
            &:after{
              content ''
              display block
              width: 100%
              height: 1px
              border-top 1px solid #eee
              margin 20px 0
            }
            .list_twoBox{
              .list_twoBox_Q{
                display flex
                align-items center
                position relative
                >div{
                  width: 40px;
                  height: 40px;
                  border-radius: 5px;
                  background #63a3fc
                  font-weight: 700;
                  font-style: normal;
                  font-size: 20px;
                  color: #fff
                  text-align: center
                  line-height:40px
                  margin-right 20px
                }
                >span {
                  font-weight: 700;
                  font-style: normal;
                  font-size: 16px;
                  color: #333
                  cursor: pointer
                }
                >p{
                  position absolute
                  right:0
                  font-size: 14px;
                  color: #A1A1A1;
                }
              }
              .list_twoBox_A{
                margin-top 20px
                display flex
                align-items center
                position relative
                >div{
                  width: 40px;
                  height: 40px;
                  border-radius: 5px;
                  background #f57a7c
                  font-weight: 700;
                  font-style: normal;
                  font-size: 20px;
                  color: #fff
                  text-align: center
                  line-height:40px
                  margin-right 20px
                }
                >span {
                  width 95%
                  font-weight: 700;
                  font-style: normal;
                  font-size: 14px;
                  color: #333
                  line-height: 22px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
                >p{
                  position absolute
                  right:0
                  top: 60px
                  font-size: 14px;
                  color: #A1A1A1;
                }
              }
              .list_twoBox_bottom{
                padding-left 60px
                display flex
                align-items center
                .doctor_head{
                  display flex
                  align-items center
                  margin-top 20px
                  >img{
                    width: 55px;
                    height: 55px;
                    border-radius 50%
                    margin-right 15px
                  }
                  .doctor_name{
                    font-weight: 700;
                    font-style: normal;
                    font-size: 14px;
                    color: #333;
                    margin-right 15px
                    max-width: 90px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .doctor_title{
                    max-width: 120px;
                    padding 0 10px
                    height: 31px;
                    font-size: 14px;
                    color: #333
                    text-align: center
                    line-height:31px
                    border-radius 5px
                    margin-right 15px
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .doctor_hospital{
                    font-size: 14px;
                    color: #333;
                    margin-right 15px
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width 150px
                  }
                  .doctor_twoTitle{
                    font-size: 14px;
                    color: #333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width 150px
                  }
                }
              }
            }
          }
        }
      }
      // 相关医生
      .correlation_doctor{
        .doctor_center{
          display flex
          flex-wrap wrap
          .item_list{
            cursor: pointer
            width: 240px;
            margin-right 60px
            margin-bottom 20px
            &:nth-child(3n){
              margin-right 0
            }
            .headerImg{
              >img{
               width: 240px;
               height: 206px;
             }
            }
            .doctor_name{
              .top{
                margin 8px 0 13px 0
                display flex
                justify-content center
                >div{
                  max-width 40%
                  margin-right 10px
                  font-weight: 700;
                  font-size: 16px;
                  color: #333
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                >span{
                  max-width 40%
                  font-weight: 400;
                  font-size: 16px;
                  color: #333
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
              .bottom{
                display flex
                justify-content center
                >div{
                  margin-right 15px
                  max-width 40%
                  font-weight: 400;
                  font-style: normal;
                  font-size: 16px;
                  color: #333
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                >span{
                  display block
                  max-width 40%
                  font-weight: 400;
                  font-style: normal;
                  font-size: 16px;
                  color: #333
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
            .doctor_info{
              >div{
                font-weight 400
                font-size: 14px;
                line-height: 22px;
                color: #333
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
                &:before{
                  content '【简介】'
                  display inline-block
                  font-weight 700
                  font-size: 14px;
                  line-height: 22px;
                }
              }

            }
          }
        }
      }
    }
    .Pagination{
      margin-top 20px
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/view-tt/search/List.vue